import React, { Component } from "react";
import { withStyles } from "@mui/styles";
import styles from './index.styles';
import QRCode from 'qrcode.react';
import noimg from './images/noimg.png'
import { Box, Grid, Typography } from "@mui/material";
import LOCATION_TYPE from '../enum/location_type';
import BOX_TYPES from '../enum/box_type';
const { getParams } = require('./common/helpers.fn');
export class LabelTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    const { classes, rxNumbers, t, boxDetails, boxId, connectionType } = this.props;
    // const { picture_url } = this.props && this.props.pharmacyDetails;
    const accountdetails = this.props && this.props.accountDetails;
    const firstname = this.props && this.props.firstName;
    const lastname = this.props && this.props.lastName;
    const dateOfBirth = this.props && this.props.dateOfBirth;
    const isCoolItem = this.props && this.props.isCoolItem;
    const locationTypeID = this.props && this.props.locationTypeID;
    // const prefer_location_name = this.props && this.props.prefer_location_name;
    const brandingName = this.props && this.props.brandingName;
    const brandPhoneNumber = this.props && this.props.brandingPhone;
    let location = {
      picture_url: '',
      name: '',
      address_line_1: '',
      address_line_2: '',
      city: '',
      state: '',
      country: '',
      zip: '',
    };
    let _boxDetails = boxDetails && boxDetails.filter((x) => x.id === boxId)[0]
    if (connectionType === 0) {
      if (_boxDetails) {
        location.picture_url = _boxDetails.picture_url;
        location.name = _boxDetails.name;
        location.address_line_1 = _boxDetails.address_line_1;
        location.address_line_2 = _boxDetails.address_line_2;
        location.city = _boxDetails.city;
        location.state = _boxDetails.state;
        location.country = _boxDetails.country;
        location.zip = _boxDetails.zip;
      }
    } else {
      if (_boxDetails) {
        location.picture_url = _boxDetails.picture_url;
        location.name = _boxDetails.name;
        location.address_line_1 = _boxDetails.address.address_line_1;
        location.address_line_2 = _boxDetails.address.address_line_2;
        location.city = _boxDetails.address.city;
        location.state = _boxDetails.address.state;
        location.country = _boxDetails.address.country;
        location.zip = _boxDetails.address.zip;
      }
    }
    let _storageCodes = localStorage.getItem('label-codes');
    let codes = {};
    if(_storageCodes) {
      codes = JSON.parse(_storageCodes);
    }

    const getBinPosition = () => {
      const { bin_id } = this.props;
      let _binId = '';
      if ([undefined, 'undefined', null, 'null', ''].includes(bin_id)) {
        _binId = localStorage.getItem('fBinIds');
      } else {
        _binId = bin_id;
      }
      const _getBinPosition = getParams(_binId);
      const columnNumber = _getBinPosition.columnNumber.toString().length <= 1 ? `0${_getBinPosition.columnNumber}` : _getBinPosition.columnNumber;
      const RowNumber = _getBinPosition.rowNumber.toString().length <= 1 ? `0${_getBinPosition.rowNumber}` : _getBinPosition.rowNumber;
      return `${_getBinPosition.direction}-C${columnNumber}-R${RowNumber} #${_binId}`
    }

    return (
      <Box component="div" id="printableArea" className={classes.boxDesign}>
        {accountdetails &&
          <Box component="div" className={classes.boxcontainer}>
            <Box component="div" className={classes.boxLogo}>
              {location && <Box component="img" alt="logo" height="30px" width="40px" src={['', null, 'null', undefined, 'undefined'].includes(location.picture_url) ? noimg : location.picture_url} />}
            </Box>
            <Box component="div" className={classes.spacer}></Box>
            <Box component="div" className={classes.boxLogoDesc}>
              {['', null, 'null', undefined, 'undefined'].includes(accountdetails.name) ? '' : accountdetails.name}<br />
            </Box>
          </Box>
        }
        {location &&
          <Box component="div" className={classes.deliveryContainer}>
            {t("Label.DeliverTo")}:<br />
            {['', null, 'null', undefined, 'undefined'].includes(location.name) ? '' : location.name}<br />
            {['', null, 'null', undefined, 'undefined'].includes(location.address_line_1) ? '' : location.address_line_1.toString().concat(',')}
            {['', null, 'null', undefined, 'undefined'].includes(location.address_line_2) ? '' : location.address_line_2}<br />
            {['', null, 'null', undefined, 'undefined'].includes(location.city) ? '' : location.city.toString().concat(',')}
            {['', null, 'null', undefined, 'undefined'].includes(location.state) ? '' : location.state.toString()}
            {['', null, 'null', undefined, 'undefined'].includes(location.country) ? '' : location.country.toString().concat('-')}
            {['', null, 'null', undefined, 'undefined'].includes(location.zip) ? '' : location.zip}
          </Box>
        }
        <Box component="div" className={classes.prescriptionContainer}>
          <Grid container>
            <Grid item xs={12}>
              <Box component="div" className={classes.qrcodeContainer}>
                {codes && codes.stockCode ? <Typography><QRCode height="70px" width="70px" includeMargin={false} renderAs={'svg'} value={codes && codes.stockCode} /></Typography> : ""}                
              </Box>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <Box component="h3" sx={{ textAlign: 'left', mb: '4px' }}>{codes && codes.stockCode}</Box>
            </Grid>
          </Grid>
          <Box component="div" sx={{ borderBottom: '1px solid #000' }}></Box>
          {_boxDetails && _boxDetails.type_id && _boxDetails.type_id === BOX_TYPES.FASTLANE ? (
            <div>
              <Grid container sx={{ mt: '5px', mb: '5px' }}>
                <Grid item xs={12}>
                  Bin Position
                </Grid>
                <Grid item xs={12}>
                  {getBinPosition()}
                </Grid>
              </Grid>
              <Box component="div" sx={{ borderBottom: '1px solid #000' }}></Box>
            </div>
          ) : (
            null
          )}
          <Grid container sx={{ mt: '5px', mb: '5px' }}>
            <Grid item xs={12}>
              {firstname}{' '}{lastname}<br />
            </Grid>
            <Grid item xs={12}>
              {dateOfBirth}
            </Grid>
            <Grid item xs={12}>
              {[LOCATION_TYPE.Kiosk].includes(locationTypeID) === true ?
                isCoolItem ? 'REFRIGERATED' : ''
                : ''
              }
            </Grid>
          </Grid>
          <Box component="div" sx={{ borderBottom: '1px solid #000' }}></Box>
          <Grid container sx={{ mt: '5px', mb: '5px' }}>
            <Grid item xs={12}>
              {t("Label.Count")} ({rxNumbers && rxNumbers.length})<br />
              {rxNumbers && rxNumbers.map((rnNo, index) => {
                return <Box component="div" key={index}>{rnNo && rnNo.toString().toUpperCase()}</Box>
              })}
            </Grid>
          </Grid>
          <Box component="div" sx={{ borderBottom: '1px solid #000' }}></Box>
          <Grid container sx={{ mt: '5px' }}>
            <Grid item xs={12}>
              <Box component="div" sx={{ fontWeight: '400', fontSize: '0.8rem' }}>
                {`${t("Label.SecMessage")} ${brandingName} at ${brandPhoneNumber}`}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    );
  }
}

export default withStyles(styles)(LabelTemplate);



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/labelTemplate.js